<template>
  <Modal :width="1280">
    <template v-slot:header>
      <div style="width: 100%; display: flex; justify-content: space-between">
        <p class="contract-modal-title">{{ titulo }}</p>
        <span
          style="cursor: pointer"
          @click="$emit('close')"
          class="material-icons-outlined"
          >close</span
        >
      </div>
    </template>
    <template v-slot:body>
      <div class="body-box">
        <div class="map-container">
          <div class="map-controllers">
            <CSelect
              placeholder="Tipo"
              :options="mapTypes"
              :value.sync="mapType"
            ></CSelect>
          </div>
          <div class="pins-controller">
            <svg
              class="pointer"
              v-if="showPins"
              @click="showPins = false"
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_7130_199565)">
                <circle cx="25" cy="22" r="20" fill="#003063" />
                <rect
                  width="20"
                  height="20"
                  transform="translate(15 12)"
                  fill="#003063"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M32.6381 22.6384C32.4191 23.7396 31.9561 24.7719 31.2929 25.6666C28.8274 23.201 26.6514 21.0271 24.7463 19.1237C23.2639 17.6426 21.9454 16.3253 20.7821 15.162C20.8884 15.0806 20.9948 15.0055 21.1011 14.9305L21.1011 14.9305C22.3399 14.1046 23.7852 13.6667 25.2742 13.6667C26.7633 13.6667 28.2148 14.1046 29.4473 14.9305C30.6798 15.7563 31.6433 16.9325 32.2126 18.3027C32.782 19.6729 32.9259 21.1807 32.6381 22.6384ZM33.5297 30.2682L33.5328 30.2713V30.2651L33.5297 30.2682ZM30.1668 26.9054L33.5297 30.2682L32.3503 31.4476L28.9844 28.0816L25.2743 31.7917L19.9625 26.4799C18.9177 25.4351 18.1982 24.0962 17.9104 22.6384C17.6163 21.1869 17.7665 19.6729 18.3358 18.3027C18.4172 18.1025 18.511 17.9085 18.6111 17.7146L15.8333 14.9367L17.0157 13.7543L19.5684 16.3069L20.7508 17.4894L28.9844 25.7229L30.1668 26.9054Z"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_7130_199565"
                  x="0"
                  y="0"
                  width="50"
                  height="50"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="3" />
                  <feGaussianBlur stdDeviation="2.5" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_7130_199565"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_7130_199565"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>

            <svg
              class="pointer"
              v-if="!showPins"
              @click="showPins = true"
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_7130_199640)">
                <rect
                  x="5"
                  y="2"
                  width="40"
                  height="40"
                  rx="20"
                  fill="#8ACC0D"
                />
                <path
                  d="M29.2427 25.576L25 29.8187L20.7573 25.576C19.9182 24.7369 19.3468 23.6678 19.1153 22.5039C18.8838 21.34 19.0026 20.1336 19.4567 19.0373C19.9109 17.9409 20.6799 17.0039 21.6666 16.3446C22.6533 15.6853 23.8133 15.3334 25 15.3334C26.1867 15.3334 27.3467 15.6853 28.3334 16.3446C29.3201 17.0039 30.0891 17.9409 30.5433 19.0373C30.9974 20.1336 31.1162 21.34 30.8847 22.5039C30.6532 23.6678 30.0818 24.7369 29.2427 25.576ZM25 22.6667C25.3536 22.6667 25.6928 22.5262 25.9428 22.2762C26.1929 22.0261 26.3333 21.687 26.3333 21.3334C26.3333 20.9797 26.1929 20.6406 25.9428 20.3905C25.6928 20.1405 25.3536 20 25 20C24.6464 20 24.3072 20.1405 24.0572 20.3905C23.8071 20.6406 23.6667 20.9797 23.6667 21.3334C23.6667 21.687 23.8071 22.0261 24.0572 22.2762C24.3072 22.5262 24.6464 22.6667 25 22.6667Z"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_7130_199640"
                  x="0"
                  y="0"
                  width="50"
                  height="50"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="3" />
                  <feGaussianBlur stdDeviation="2.5" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_7130_199640"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_7130_199640"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <div class="polygon-controller">
            <svg
              class="pointer"
              v-if="showPolygons"
              @click="showPolygons = false"
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_7130_199566)">
                <circle cx="25" cy="22" r="20" fill="#003063" />
                <rect
                  width="20"
                  height="20"
                  transform="translate(15 12)"
                  fill="#003063"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M26.0292 23.025L32.2583 29.2542V29.2625L33.2542 30.2583L33.2583 30.2542V30.2625L33.2583 30.2625L33.2583 30.2625V30.2625L32.0792 31.4417L30.1417 29.5042H27.1708L26.5375 25.9L24.4833 23.8458L25.4792 29.5042H18.3375C17.8792 29.5042 17.5042 29.1292 17.5042 28.6708V24.1708L23.7125 23.075L22.275 21.6375L17.5042 22.4792V16.8708L15.5625 14.9292L16.7458 13.7458L17.7458 14.7458L23.975 20.975L26.0292 23.025ZM22.8333 14.5H19.8625L23.4666 18.1042L22.8333 14.5ZM32.5 27.1333V27.1375H32.5042L32.5 27.1333ZM25.525 20.1583L32.5 27.1333V15.3333C32.5 14.875 32.125 14.5 31.6667 14.5H24.525L25.525 20.1583Z"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_7130_199566"
                  x="0"
                  y="0"
                  width="50"
                  height="50"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="3" />
                  <feGaussianBlur stdDeviation="2.5" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_7130_199566"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_7130_199566"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
            <svg
              class="pointer"
              v-if="!showPolygons"
              @click="showPolygons = true"
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_7130_199642)">
                <rect
                  x="5"
                  y="2"
                  width="40"
                  height="40"
                  rx="20"
                  fill="#8ACC0D"
                />
                <path
                  d="M24.4593 22.7713L25.38 28H19.6667C19.2987 28 19 27.7013 19 27.3333V23.7347L24.4593 22.7713ZM30.3333 16C30.7013 16 31 16.2987 31 16.6667V27.3333C31 27.7013 30.7013 28 30.3333 28H26.7347L24.6187 16H30.3333ZM23.2647 16L24.2273 21.4587L19 22.38V16.6667C19 16.2987 19.2987 16 19.6667 16H23.2647Z"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_7130_199642"
                  x="0"
                  y="0"
                  width="50"
                  height="50"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="3" />
                  <feGaussianBlur stdDeviation="2.5" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_7130_199642"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_7130_199642"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <div class="heatmap-controller">
            <svg
              class="pointer"
              v-if="showHeatMap"
              @click="
                showHeatMap = false;
                clearHeatMap();
              "
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_7130_199564)">
                <circle cx="25" cy="22" r="20" fill="#003063" />
                <rect
                  width="20"
                  height="20"
                  transform="translate(15 12)"
                  fill="#003063"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M33.8335 29.6709L17.3335 13.1709L16.1543 14.35L21.4835 19.6792C21.3561 19.7955 21.2329 19.9052 21.117 20.0084L21.117 20.0084C20.9712 20.1382 20.837 20.2576 20.721 20.3667C19.8085 21.225 19.1751 22.3375 18.9043 23.5584C18.6335 24.7792 18.7335 26.0584 19.196 27.2209C19.6585 28.3834 20.4585 29.3834 21.496 30.0875C22.5335 30.7917 23.7543 31.1667 25.0085 31.1667C26.6668 31.1667 28.2543 30.5084 29.4293 29.3375C29.721 29.0459 29.971 28.725 30.196 28.3834L32.6585 30.8459L33.8335 29.6709ZM26.721 24.9125H26.675C26.6805 24.9068 26.6902 24.8962 26.696 24.8875L26.721 24.9125ZM30.8334 22.8584C30.5668 23.1209 30.3126 23.3542 30.0709 23.5542L31.2376 24.7209C31.2084 24.0709 31.0376 23.4459 30.8334 22.8584ZM24.1709 13.25C28.2167 15.9458 30.6209 18.6458 28.7459 22.225L23.5625 17.0417C24.0417 16.0458 24.325 14.8042 24.1709 13.25Z"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_7130_199564"
                  x="0"
                  y="0"
                  width="50"
                  height="50"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="3" />
                  <feGaussianBlur stdDeviation="2.5" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_7130_199564"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_7130_199564"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
            <svg
              class="pointer"
              v-if="!showHeatMap"
              @click="
                showHeatMap = true;
                setHeatMap();
              "
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_7130_199641)">
                <rect
                  x="5"
                  y="2"
                  width="40"
                  height="40"
                  rx="20"
                  fill="#8ACC0D"
                />
                <path
                  d="M25.0001 29.3333C23.9982 29.3332 23.0194 29.0322 22.1907 28.4691C21.3619 27.9061 20.7215 27.1071 20.3523 26.1757C19.9831 25.2443 19.9023 24.2235 20.1203 23.2456C20.3382 22.2677 20.8449 21.3778 21.5747 20.6913C22.4694 19.8493 24.6667 18.3333 24.3334 15C28.3334 17.6667 30.3334 20.3333 26.3334 24.3333C27.0001 24.3333 28.0001 24.3333 29.6667 22.6867C29.8467 23.202 30.0001 23.756 30.0001 24.3333C30.0001 25.6594 29.4733 26.9312 28.5356 27.8689C27.5979 28.8065 26.3261 29.3333 25.0001 29.3333Z"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_7130_199641"
                  x="0"
                  y="0"
                  width="50"
                  height="50"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="3" />
                  <feGaussianBlur stdDeviation="2.5" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_7130_199641"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_7130_199641"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <GmapMap
            ref="googleMap"
            :class="!avaliacao ? 'mapa2' : 'mapa'"
            :key="mapKey"
            :center="center"
            :zoom="zoom"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: true,
              fullscreenControl: false,
              mapTypeId: mapType,
              gestureHandling: 'greedy',
              disableDefaultUi: true,
            }"
          >
            <div v-if="showPolygons">
              <div
                v-for="polygon of polygons"
                :key="'polygon-' + Math.random() + polygon.id"
              >
                <GmapPolygon
                  ref="polygon-neighborhood"
                  :paths="polygon.latlngs"
                  :options="polygon.options"
                />
              </div>
            </div>
            <div v-if="showPins">
              <div v-for="pin of pins" :key="'pin-' + Math.random() + pin.id">
                <GmapCustomMarker
                  class="mt-3 pin-marker"
                  :draggable="false"
                  :marker="pin.center"
                >
                  <span class="pin-qtd">{{ pin.number }}</span>
                </GmapCustomMarker>
              </div>
            </div>
          </GmapMap>

          <div v-if="avaliacao === true" class="tela-monitor">
            <div class="evaluation-title mb-3">Avalie o zelador</div>
            <div class="evaluation-date mb-3">
              <svg
                class="mr-2"
                style="margin-bottom: 3px"
                width="15"
                height="14"
                viewBox="0 0 15 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.833252 7.00004H14.1666V13C14.1666 13.1769 14.0963 13.3464 13.9713 13.4714C13.8463 13.5965 13.6767 13.6667 13.4999 13.6667H1.49992C1.32311 13.6667 1.15354 13.5965 1.02851 13.4714C0.90349 13.3464 0.833252 13.1769 0.833252 13V7.00004ZM10.8333 1.66671H13.4999C13.6767 1.66671 13.8463 1.73695 13.9713 1.86197C14.0963 1.98699 14.1666 2.15656 14.1666 2.33337V5.66671H0.833252V2.33337C0.833252 2.15656 0.90349 1.98699 1.02851 1.86197C1.15354 1.73695 1.32311 1.66671 1.49992 1.66671H4.16659V0.333374H5.49992V1.66671H9.49992V0.333374H10.8333V1.66671Z"
                  fill="#29334E"
                />
              </svg>
              {{ formatDate(dates.start) }} - {{ formatDate(dates.end) }}
            </div>
            <div class="mb-3">
              <multiselect
                v-model="evaluation"
                :options="evaluationOptions"
                track-by="name"
                :showLabels="false"
                placeholder=""
                :multiple="false"
                label="name"
                class="evaluation-selector"
              ></multiselect>
            </div>
            <Button
              name="Avaliar e distratar"
              @clicked="handleDistractClick"
              type="delete"
              :disabled="!evaluation || loadingData"
              size="small"
            />
          </div>
        </div>

        <!--------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
        <div class="timeline-box">
          <div class="mt-3 timeline-modal">
            <div class="timeline-info">
              <div class="timeline-info__item">
                <div class="d-flex align-items-start flex-column">
                  <div class="timeline-info__label">Execuções</div>
                  <div class="timeline-info__counter">
                    {{ timeline.length }}
                  </div>
                </div>

                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 44 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.1721 27.2772L16.9602 25.9689C16.6146 25.5958 16.032 25.5736 15.6589 25.9192L15.5367 26.0324C15.1636 26.378 15.1413 26.9607 15.4869 27.3337L16.6988 28.642C17.0444 29.0151 17.627 29.0374 18.0001 28.6918L18.1224 28.5785C18.4955 28.2329 18.5177 27.6503 18.1721 27.2772Z"
                    fill="#5CCDF2"
                  />
                  <path
                    d="M28.5625 24.5C30.461 24.5 32 22.961 32 21.0625C32 19.164 30.461 17.625 28.5625 17.625C26.664 17.625 25.125 19.164 25.125 21.0625C25.125 22.961 26.664 24.5 28.5625 24.5Z"
                    fill="#5C7B9B"
                  />
                  <path
                    d="M19.1667 30.775C19.7723 30.8145 20.3802 30.8006 20.9833 30.7333L21.5833 30.6375H21.6167C24.8625 30.0125 27.375 28.1375 29.0875 25.1042C30.7542 22.1333 30.9292 18.7583 29.6 14.7875C29.5055 14.4356 29.3234 14.1134 29.0705 13.8511C28.8176 13.5888 28.5024 13.3948 28.1542 13.2875C27.7955 13.2131 27.4238 13.2311 27.074 13.3397C26.7242 13.4483 26.4077 13.6439 26.1542 13.9083C25.3827 14.673 24.3842 15.1671 23.3083 15.3167C22.1375 15.4583 20.95 15.525 19.8042 15.5917H19.5667C18.2577 15.6004 16.9706 15.9279 15.8167 16.5458C12.6458 18.4333 10.75 22.525 13.25 26.7042C13.311 26.804 13.3639 26.9085 13.4083 27.0167L13.5292 27.3125L13.3542 27.575C12.8996 28.2746 12.4823 28.9979 12.1042 29.7417C12.0899 29.7731 12.0825 29.8072 12.0825 29.8417C12.0825 29.8762 12.0899 29.9103 12.1042 29.9417C12.1139 29.9744 12.1304 30.0046 12.1527 30.0305C12.175 30.0564 12.2024 30.0772 12.2333 30.0917C12.2637 30.1075 12.2968 30.1171 12.3309 30.12C12.365 30.1229 12.3993 30.119 12.4319 30.1086C12.4644 30.0981 12.4946 30.0813 12.5206 30.059C12.5466 30.0368 12.5679 30.0097 12.5833 29.9792C13.3231 28.5102 14.232 27.1328 15.2917 25.875L15.7083 25.3792L16.1667 25.8458C16.4 26.0833 16.6917 26.3875 16.9667 26.6792C17.0171 26.7311 17.086 26.761 17.1583 26.7625C17.2251 26.7633 17.2894 26.7379 17.3375 26.6917C17.3882 26.6438 17.4181 26.578 17.4208 26.5083C17.4221 26.4739 17.4165 26.4396 17.4044 26.4074C17.3922 26.3752 17.3737 26.3458 17.35 26.3208C16.9792 25.925 16.7125 25.6458 16.5167 25.4417L16.1 24.9958L16.5542 24.5792C17.2312 23.9456 17.968 23.3791 18.7542 22.8875C19.7671 22.2237 20.8991 21.7624 22.0875 21.5292C22.1569 21.5198 22.2198 21.4835 22.2627 21.4282C22.3056 21.3728 22.325 21.3029 22.3167 21.2333C22.3126 21.1993 22.3017 21.1664 22.2848 21.1366C22.2679 21.1068 22.2451 21.0807 22.218 21.0597C22.1908 21.0388 22.1598 21.0234 22.1267 21.0146C22.0935 21.0058 22.059 21.0037 22.025 21.0083C20.7731 21.2383 19.5801 21.7172 18.5167 22.4167L17.575 22.9917V21.8875C17.575 21.6833 17.575 21.4708 17.575 21.2833C17.5755 21.2487 17.5691 21.2143 17.5563 21.1821C17.5434 21.1499 17.5243 21.1206 17.5 21.0958C17.4519 21.0455 17.3862 21.0157 17.3167 21.0125C17.2478 21.0114 17.1812 21.0374 17.1313 21.0849C17.0814 21.1325 17.0522 21.1978 17.05 21.2667C17.0167 22.3083 17.0125 22.825 17.05 23.1042V23.4125L16.8125 23.6083C15.9392 24.3413 15.1408 25.1592 14.4292 26.05L13.9042 26.7333L13.4667 25.9542C12.9868 25.0619 12.7218 24.0699 12.6929 23.0572C12.664 22.0445 12.8719 21.039 13.3 20.1208C13.6874 19.2055 14.2875 18.3957 15.0506 17.7587C15.8137 17.1217 16.7176 16.6759 17.6875 16.4583C18.6501 16.2805 19.6255 16.1816 20.6042 16.1625L21.3375 16.1292C23.1375 16.025 25.0042 15.7458 26.45 14.3875C27.125 13.7542 27.7 13.7417 28.0375 13.8458C28.375 13.95 28.8708 14.2625 29.0792 15.15C29.4088 16.3313 29.647 17.5363 29.7917 18.7542C29.949 20.2079 29.7964 21.6785 29.344 23.0689C28.8915 24.4594 28.1494 25.7381 27.1667 26.8208C26.1745 27.8909 24.9686 28.7406 23.6271 29.3148C22.2855 29.8891 20.8383 30.175 19.3792 30.1542H19.2875C19.2238 30.1534 19.1604 30.1632 19.1 30.1833C19.0705 30.1893 19.0422 30.2006 19.0167 30.2167C18.9786 30.2436 18.9474 30.2791 18.9257 30.3204C18.904 30.3617 18.8923 30.4075 18.8917 30.4542C18.8877 30.4935 18.8917 30.5332 18.9035 30.5709C18.9153 30.6086 18.9347 30.6435 18.9604 30.6735C18.9861 30.7035 19.0177 30.728 19.0531 30.7455C19.0886 30.7629 19.1272 30.7729 19.1667 30.775Z"
                    fill="black"
                  />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="43"
                    height="43"
                    rx="21.5"
                    stroke="#C6C9D0"
                  />
                </svg>
              </div>
              <div class="timeline-info__item">
                <div class="d-flex align-items-start flex-column">
                  <div class="timeline-info__label">Fotos</div>
                  <div class="timeline-info__counter">{{ pins.length }}</div>
                </div>

                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 44 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.5209 19.9292H14.0334C12.938 19.9292 12.05 20.8171 12.05 21.9125V28.1292C12.05 29.2245 12.938 30.1125 14.0334 30.1125H14.5209C15.6162 30.1125 16.5042 29.2245 16.5042 28.1292V21.9125C16.5042 20.8171 15.6162 19.9292 14.5209 19.9292Z"
                    fill="#5CCDF2"
                  />
                  <path
                    d="M27.2208 23.6958C28.9582 23.6958 30.3666 22.2874 30.3666 20.55C30.3666 18.8126 28.9582 17.4042 27.2208 17.4042C25.4834 17.4042 24.075 18.8126 24.075 20.55C24.075 22.2874 25.4834 23.6958 27.2208 23.6958Z"
                    fill="#5C7B9B"
                  />
                  <path
                    d="M30.3584 29.7833H30.6125C30.8221 29.7738 31.0268 29.7172 31.2115 29.6176C31.3962 29.5181 31.556 29.3782 31.6792 29.2083C31.8666 28.9466 31.9619 28.63 31.95 28.3083C31.95 26.4792 31.95 24.625 31.95 22.8292V19.9458C31.95 19.1125 31.95 18.2792 31.95 17.4458C31.9558 17.1725 31.8795 16.9037 31.731 16.6742C31.5824 16.4447 31.3684 16.265 31.1167 16.1583C30.896 16.0643 30.656 16.0243 30.4167 16.0417H28.4375C28.2681 16.061 28.0976 16.0168 27.959 15.9174C27.8204 15.8181 27.7236 15.6708 27.6875 15.5042L27.55 15.1125V15.0792L27.4167 14.7208C27.3491 14.4698 27.1969 14.2498 26.9858 14.098C26.7748 13.9462 26.5179 13.8718 26.2584 13.8875H23.025C22.7682 13.8728 22.5142 13.9479 22.3067 14.0999C22.0991 14.252 21.9509 14.4715 21.8875 14.7208C21.8375 14.8542 21.7917 14.9875 21.7459 15.1375L21.5834 15.5792C21.5475 15.6924 21.4789 15.7924 21.3862 15.8665C21.2935 15.9407 21.1808 15.9857 21.0625 15.9958C20.8641 16.0063 20.6652 16.0063 20.4667 15.9958H20.125V15.7042C20.125 15.5375 20.125 15.3833 20.125 15.2292C20.1253 15.0251 20.0472 14.8288 19.9069 14.6807C19.7665 14.5326 19.5746 14.444 19.3709 14.4333C18.625 14.4333 17.9 14.4333 17.0334 14.4333C16.926 14.4354 16.8204 14.4615 16.7245 14.5098C16.6286 14.5582 16.5447 14.6274 16.4792 14.7125C16.4561 14.7328 16.4377 14.7578 16.425 14.7859C16.4124 14.8139 16.4058 14.8443 16.4058 14.875C16.4058 14.9057 16.4124 14.9361 16.425 14.9641C16.4377 14.9922 16.4561 15.0172 16.4792 15.0375C16.498 15.0595 16.5213 15.0771 16.5475 15.0892C16.5738 15.1013 16.6024 15.1076 16.6313 15.1076C16.6602 15.1076 16.6888 15.1013 16.715 15.0892C16.7413 15.0771 16.7646 15.0595 16.7834 15.0375C16.8535 14.9847 16.9336 14.9468 17.0188 14.926C17.1041 14.9053 17.1927 14.9021 17.2792 14.9167H19.1292C19.2097 14.911 19.2904 14.911 19.3709 14.9167C19.4464 14.9242 19.5169 14.9579 19.5701 15.0119C19.6234 15.0659 19.6561 15.1369 19.6625 15.2125C19.6625 15.3833 19.6625 15.5542 19.6625 15.7333V16.0292H15.9584C15.8062 16.0232 15.6539 16.0344 15.5042 16.0625C15.1832 16.13 14.8964 16.3088 14.6944 16.5673C14.4923 16.8257 14.3881 17.1472 14.4 17.475C14.4 19.5583 14.4 21.725 14.4 23.7958V25.9833C14.3956 26.0277 14.3956 26.0723 14.4 26.1167C14.4091 26.1704 14.4373 26.2189 14.4794 26.2534C14.5216 26.2879 14.5748 26.3059 14.6292 26.3042C14.6834 26.3067 14.7365 26.2889 14.7782 26.2542C14.8198 26.2195 14.847 26.1704 14.8542 26.1167C14.8584 26.0556 14.8584 25.9944 14.8542 25.9333V20.1333C14.8542 19.2542 14.8542 18.3458 14.8542 17.45C14.8486 17.2155 14.931 16.9875 15.0853 16.8109C15.2396 16.6342 15.4545 16.5218 15.6875 16.4958C15.7791 16.4896 15.871 16.4896 15.9625 16.4958H20.9084C21.1593 16.5125 21.4084 16.442 21.6134 16.2962C21.8184 16.1505 21.9667 15.9384 22.0334 15.6958C22.0834 15.5583 22.1292 15.4167 22.1792 15.2792V15.2458C22.2209 15.1208 22.2625 15 22.3084 14.8792C22.3405 14.7251 22.4285 14.5883 22.5554 14.4953C22.6824 14.4022 22.8392 14.3593 22.9959 14.375H26.2834C26.4426 14.3531 26.6042 14.3913 26.7368 14.4822C26.8693 14.5732 26.9632 14.7102 27 14.8667C27.0375 14.9792 27.0792 15.0875 27.1167 15.2C27.1709 15.3625 27.2334 15.5458 27.3 15.725C27.3581 15.9031 27.4617 16.0629 27.6006 16.1886C27.7394 16.3143 27.9087 16.4015 28.0917 16.4417C28.2095 16.4662 28.3298 16.476 28.45 16.4708H30.4917C30.6853 16.4561 30.8787 16.503 31.044 16.6048C31.2094 16.7066 31.3384 16.858 31.4125 17.0375C31.4753 17.1966 31.5064 17.3665 31.5042 17.5375C31.5042 20.2125 31.5042 22.9542 31.5042 25.3917V27.4167C31.5042 27.7125 31.5042 28.05 31.5042 28.3833C31.5088 28.6256 31.4186 28.86 31.2528 29.0367C31.087 29.2134 30.8587 29.3183 30.6167 29.3292C30.5125 29.3292 30.4042 29.3292 30.3 29.3292H16.0875C15.9625 29.3292 15.8167 29.3292 15.6709 29.3292C15.5599 29.3186 15.4523 29.2858 15.3542 29.2328C15.2562 29.1799 15.1697 29.1078 15.1 29.0208C14.993 28.895 14.9178 28.7453 14.8808 28.5843C14.8438 28.4233 14.8461 28.2558 14.8875 28.0958V28.0417H15.75H16.7834C17.0681 28.0235 17.3351 27.8966 17.5289 27.6873C17.7228 27.4779 17.8288 27.202 17.825 26.9167C17.825 25.7292 17.825 24.5125 17.825 23.4375V23.325C17.825 22.525 17.825 21.7292 17.825 20.9292C17.8312 20.7825 17.8078 20.6361 17.7563 20.4986C17.7047 20.3612 17.6261 20.2355 17.5251 20.129C17.424 20.0225 17.3026 19.9374 17.168 19.8787C17.0335 19.8201 16.8885 19.789 16.7417 19.7875C16.575 19.7875 16.4 19.7875 16.2292 19.7875H16.1667C16.1156 19.79 16.065 19.7998 16.0167 19.8167C15.9729 19.8332 15.9359 19.8639 15.9117 19.904C15.8875 19.944 15.8776 19.9911 15.8834 20.0375C15.8833 20.0812 15.8981 20.1236 15.9254 20.1577C15.9526 20.1917 15.9907 20.2155 16.0334 20.225C16.1026 20.2436 16.1742 20.252 16.2459 20.25H16.7334C16.8918 20.2548 17.0428 20.3186 17.1568 20.4287C17.2709 20.5389 17.3397 20.6876 17.35 20.8458C17.3541 20.9055 17.3541 20.9653 17.35 21.025V26.7042C17.348 26.7249 17.348 26.7459 17.35 26.7667C17.3542 26.8333 17.3542 26.9001 17.35 26.9667C17.3374 27.0948 17.2866 27.2161 17.2041 27.3149C17.1216 27.4138 17.0113 27.4855 16.8875 27.5208C16.7925 27.5463 16.6942 27.5575 16.5959 27.5542H14.7334C14.475 27.5542 14.4 27.6292 14.4 27.8958V28.0083C14.4 28.1375 14.4 28.2708 14.4 28.4042C14.4063 28.6701 14.4879 28.9287 14.6355 29.15C14.783 29.3713 14.9903 29.5461 15.2334 29.6542C15.4714 29.7494 15.7275 29.7907 15.9834 29.775H30.3584V29.7833Z"
                    fill="black"
                  />
                  <path
                    d="M21.8043 18.0917C20.7594 18.6403 19.9288 19.5237 19.4456 20.6004C18.9625 21.6771 18.8546 22.8849 19.1394 24.0302C19.4241 25.1755 20.085 26.1921 21.0162 26.9171C21.9474 27.6422 23.0949 28.0338 24.2751 28.0292C25.1786 28.0302 26.0671 27.7977 26.8543 27.3542C27.8181 26.8116 28.587 25.9797 29.0522 24.9763C29.5175 23.9728 29.6555 22.8485 29.4468 21.7623C29.2382 20.6761 28.6933 19.683 27.8894 18.9233C27.0854 18.1637 26.063 17.676 24.9668 17.5292C24.7306 17.4984 24.4924 17.4858 24.2543 17.4917C24.2235 17.4905 24.1928 17.4957 24.1642 17.507C24.1355 17.5184 24.1096 17.5356 24.088 17.5576C24.0664 17.5796 24.0497 17.6058 24.0389 17.6346C24.028 17.6635 24.0233 17.6943 24.0251 17.725C24.0228 17.7557 24.0266 17.7865 24.0363 17.8156C24.046 17.8448 24.0613 17.8718 24.0815 17.895C24.1016 17.9183 24.1261 17.9373 24.1536 17.951C24.1812 17.9647 24.2111 17.9729 24.2418 17.975C24.2819 17.9793 24.3224 17.9793 24.3626 17.975H24.3918C25.0935 17.9919 25.7826 18.1656 26.4084 18.4833C27.371 18.9649 28.1425 19.7578 28.5975 20.7332C29.0525 21.7086 29.1643 22.8092 28.9148 23.8562C28.6652 24.9032 28.0689 25.8351 27.2229 26.5003C26.3768 27.1656 25.3306 27.5253 24.2543 27.5208C24.058 27.5226 23.8619 27.5129 23.6668 27.4917C22.5085 27.3447 21.4444 26.7778 20.6764 25.8984C19.9084 25.019 19.4898 23.8883 19.5001 22.7208C19.4999 21.8608 19.7361 21.0173 20.1829 20.2825C20.6297 19.5477 21.2698 18.9498 22.0334 18.5542L22.1126 18.5125C22.1603 18.4895 22.2063 18.4631 22.2501 18.4333C22.3003 18.4029 22.3369 18.3545 22.3524 18.2979C22.3679 18.2413 22.3611 18.1809 22.3334 18.1292C22.3139 18.0882 22.2832 18.0536 22.2449 18.0293C22.2065 18.005 22.1622 17.9919 22.1168 17.9917H22.0418C21.9721 18.0152 21.9051 18.046 21.8418 18.0833L21.8043 18.0917Z"
                    fill="black"
                  />
                  <path
                    d="M27.8334 22.7125C27.8308 22.5437 27.8169 22.3753 27.7917 22.2083C27.7223 21.7392 27.5583 21.289 27.3098 20.885C27.0613 20.4811 26.7333 20.1318 26.3459 19.8583C25.7395 19.4192 25.0112 19.1803 24.2625 19.175C24.0629 19.1749 23.8635 19.1916 23.6667 19.225C22.8285 19.3776 22.0707 19.8202 21.526 20.4753C20.9813 21.1305 20.6845 21.9564 20.6875 22.8083C20.6995 23.7449 21.0786 24.6394 21.7433 25.2994C22.4079 25.9594 23.305 26.3321 24.2417 26.3375H24.2667C25.1167 26.3335 25.9377 26.0279 26.5834 25.475C26.8855 25.2286 27.1385 24.9275 27.3292 24.5875C27.3476 24.5607 27.3601 24.5304 27.3659 24.4984C27.3717 24.4664 27.3706 24.4336 27.3627 24.402C27.3548 24.3705 27.3403 24.341 27.3202 24.3155C27.3 24.29 27.2747 24.2691 27.2459 24.2542C27.1923 24.2219 27.1284 24.2112 27.0672 24.2244C27.0061 24.2375 26.9522 24.2735 26.9167 24.325C26.8917 24.3583 26.8709 24.3917 26.85 24.425C26.8362 24.4495 26.8209 24.4732 26.8042 24.4958C26.407 25.0742 25.825 25.5003 25.1537 25.7041C24.4823 25.9079 23.7617 25.8773 23.11 25.6173C22.4584 25.3574 21.9145 24.8835 21.5678 24.2736C21.2211 23.6637 21.0921 22.954 21.2021 22.261C21.3121 21.5681 21.6545 20.9332 22.173 20.4607C22.6916 19.9881 23.3554 19.7059 24.0555 19.6605C24.7557 19.6151 25.4504 19.8092 26.0256 20.2109C26.6008 20.6126 27.0223 21.1979 27.2209 21.8708C27.2738 22.0759 27.31 22.2849 27.3292 22.4958C27.3292 22.575 27.3292 22.6542 27.3584 22.7333C27.3834 22.9083 27.4834 23.0125 27.6167 23.0042C27.6502 22.9996 27.6825 22.9884 27.7116 22.9711C27.7408 22.9539 27.7662 22.9311 27.7864 22.9039C27.8065 22.8767 27.8211 22.8458 27.8292 22.8129C27.8372 22.7801 27.8387 22.7459 27.8334 22.7125Z"
                    fill="black"
                  />
                  <path
                    d="M25.7834 15.5042C25.7334 15.5042 23.5584 15.5042 23.5084 15.5042C23.4514 15.5104 23.3987 15.5379 23.3609 15.5811C23.3231 15.6243 23.3029 15.6801 23.3043 15.7375C23.3028 15.7954 23.3229 15.8517 23.3606 15.8956C23.3983 15.9395 23.451 15.9678 23.5084 15.975C23.5501 15.975 25.7043 15.975 25.7793 15.975C25.8374 15.9673 25.8907 15.9388 25.9293 15.8947C25.968 15.8506 25.9893 15.794 25.9893 15.7354C25.9893 15.6768 25.968 15.6202 25.9293 15.5761C25.8907 15.532 25.8374 15.5035 25.7793 15.4958L25.7834 15.5042Z"
                    fill="black"
                  />
                  <path
                    d="M30.1376 27.6125H28.9876C28.9323 27.6053 28.8762 27.6053 28.8209 27.6125C28.7745 27.6272 28.7341 27.6568 28.7063 27.6967C28.6784 27.7366 28.6645 27.7847 28.6667 27.8333C28.6616 27.8834 28.673 27.9339 28.6994 27.9768C28.7258 28.0197 28.7655 28.0528 28.8126 28.0708C28.872 28.0888 28.9339 28.0972 28.9959 28.0958H30.1251C30.2386 28.1021 30.3507 28.0682 30.4417 28C30.4791 27.9559 30.4985 27.8994 30.4959 27.8417C30.4917 27.6958 30.3709 27.6125 30.1376 27.6125Z"
                    fill="black"
                  />
                  <path
                    d="M29.3791 26.375C29.3768 26.4051 29.3805 26.4354 29.39 26.4641C29.3994 26.4927 29.4145 26.5192 29.4342 26.5421C29.454 26.5649 29.478 26.5837 29.505 26.5972C29.532 26.6107 29.5614 26.6187 29.5916 26.6208C29.8206 26.6333 30.0501 26.6333 30.2791 26.6208C30.3366 26.6167 30.3906 26.5915 30.4306 26.5499C30.4706 26.5084 30.4938 26.4535 30.4957 26.3958C30.4981 26.3338 30.4765 26.2732 30.4354 26.2266C30.3942 26.1801 30.3368 26.1511 30.2749 26.1458H29.5957C29.5382 26.1518 29.4846 26.1781 29.4449 26.2202C29.4051 26.2623 29.3818 26.3172 29.3791 26.375Z"
                    fill="black"
                  />
                  <path
                    d="M17.4709 17.4167C17.277 17.4167 17.0875 17.4742 16.9264 17.582C16.7653 17.6898 16.6398 17.8429 16.5658 18.0221C16.4918 18.2013 16.4727 18.3983 16.5108 18.5884C16.5489 18.7784 16.6426 18.9529 16.78 19.0897C16.9173 19.2265 17.0922 19.3194 17.2824 19.3567C17.4726 19.394 17.6696 19.374 17.8485 19.2993C18.0273 19.2245 18.1799 19.0984 18.287 18.9368C18.3941 18.7752 18.4508 18.5855 18.45 18.3917C18.45 18.2633 18.4247 18.1362 18.3754 18.0176C18.3262 17.899 18.254 17.7914 18.163 17.7008C18.072 17.6102 17.964 17.5384 17.8453 17.4897C17.7265 17.4409 17.5992 17.4161 17.4709 17.4167ZM18.0459 18.3917C18.0467 18.5056 18.0137 18.6171 17.951 18.7122C17.8883 18.8074 17.7988 18.8817 17.6938 18.9259C17.5888 18.97 17.4731 18.982 17.3613 18.9603C17.2494 18.9386 17.1466 18.8841 17.0658 18.8039C16.9849 18.7236 16.9298 18.6212 16.9072 18.5096C16.8847 18.3979 16.8958 18.2821 16.9392 18.1768C16.9826 18.0715 17.0563 17.9814 17.151 17.918C17.2456 17.8547 17.357 17.8208 17.4709 17.8208C17.6205 17.8208 17.7643 17.8791 17.8717 17.9833C17.979 18.0876 18.0415 18.2296 18.0459 18.3792V18.3917Z"
                    fill="black"
                  />
                  <rect
                    x="0.5"
                    y="0.5"
                    width="43"
                    height="43"
                    rx="21.5"
                    stroke="#C6C9D0"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div class="mt-3 timeline-photos">
            <div class="timeline-header">
              <div class="timeline-header__title">
                Atividades de {{ formatDate(dates.start) }} -{{
                  formatDate(dates.end)
                }}
              </div>
            </div>
            <div
              v-for="item of timeline"
              :key="item.execucao_uuid"
              class="timeline-list"
            >
              <div
                class="d-flex w-100 justify-content-between align-items-center"
              >
                <div>
                  <div class="activity-name">
                    <img
                      :src="item.atividade_icon"
                      alt=""
                      width="24"
                      class="mr-2"
                    />{{ item.atividade_nome }}
                  </div>
                  <div class="activity-date mt-2">
                    <svg
                      style="margin-bottom: 3px"
                      class="mr-2"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.333252 7.33332H13.6666V13.3333C13.6666 13.5101 13.5963 13.6797 13.4713 13.8047C13.3463 13.9298 13.1767 14 12.9999 14H0.999919C0.823108 14 0.653538 13.9298 0.528514 13.8047C0.40349 13.6797 0.333252 13.5101 0.333252 13.3333V7.33332ZM10.3333 1.99999H12.9999C13.1767 1.99999 13.3463 2.07023 13.4713 2.19525C13.5963 2.32028 13.6666 2.48985 13.6666 2.66666V5.99999H0.333252V2.66666C0.333252 2.48985 0.40349 2.32028 0.528514 2.19525C0.653538 2.07023 0.823108 1.99999 0.999919 1.99999H3.66659V0.666656H4.99992V1.99999H8.99992V0.666656H10.3333V1.99999Z"
                        fill="#29334E"
                      />
                    </svg>
                    {{ formatDate(item.execucao_data_fim) }}
                  </div>
                </div>
                <div class="activity-qtd">
                  {{ item.execucao_timeline.length }} Fotos
                </div>
              </div>
              <div class="mt-4">
                <div
                  v-for="photo of item.execucao_timeline"
                  :key="photo.execucao_timeline_uuid"
                  class="mb-5 timeline-photo"
                >
                  <div v-if="photo.tags.length">
                    {{ photo.tags[0].tag_descricao }}
                  </div>
                  <div>{{ onlyTime(photo.execucao_timeline_data) }}</div>
                  <div>
                    {{ photo.execucao_timeline_lat }},
                    {{ photo.execucao_timeline_lng }}
                  </div>
                  <img
                    :src="photo.execucao_timeline_foto_thumb"
                    width="100%"
                    alt=""
                    class="mt-3 timeline-img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer v-if="this.avaliacao === true">
      <div class="tela-mobile">
        <div class="evaluation-title mb-3">Avalie o zelador</div>
        <div class="evaluation-date mb-3">
          <svg
            class="mr-2"
            style="margin-bottom: 3px"
            width="15"
            height="14"
            viewBox="0 0 15 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.833252 7.00004H14.1666V13C14.1666 13.1769 14.0963 13.3464 13.9713 13.4714C13.8463 13.5965 13.6767 13.6667 13.4999 13.6667H1.49992C1.32311 13.6667 1.15354 13.5965 1.02851 13.4714C0.90349 13.3464 0.833252 13.1769 0.833252 13V7.00004ZM10.8333 1.66671H13.4999C13.6767 1.66671 13.8463 1.73695 13.9713 1.86197C14.0963 1.98699 14.1666 2.15656 14.1666 2.33337V5.66671H0.833252V2.33337C0.833252 2.15656 0.90349 1.98699 1.02851 1.86197C1.15354 1.73695 1.32311 1.66671 1.49992 1.66671H4.16659V0.333374H5.49992V1.66671H9.49992V0.333374H10.8333V1.66671Z"
              fill="#29334E"
            />
          </svg>
          {{ formatDate(dates.start) }} - {{ formatDate(dates.end) }}
        </div>
        <div class="mb-3">
          <multiselect
            v-model="evaluation"
            :options="evaluationOptions"
            track-by="name"
            :showLabels="false"
            placeholder=""
            :multiple="false"
            label="name"
            class="evaluation-selector"
          ></multiselect>
        </div>
        <Button
          name="Avaliar e distratar"
          @clicked="handleDistractClick"
          type="delete"
          :disabled="!evaluation || loadingData"
          size="small"
        />
      </div>
    </template>
  </Modal>
</template>

<script>
import GmapCustomMarker from "vue2-gmap-custom-marker";
import Multiselect from "vue-multiselect";

import Modal from "../components/Modal.vue";
import Button from "../components/Button.vue";

export default {
  name: "CancellationModal",
  components: {
    Modal,
    GmapCustomMarker,
    Multiselect,
    Button,
  },
  props: {
    polygons: {
      type: Array,
      default: () => [],
    },
    pins: {
      type: Array,
      default: () => [],
    },
    tracking: {
      type: Array,
      default: () => [],
    },
    timeline: {
      type: Array,
      default: () => [],
    },
    dates: {
      type: Object,
      default: () => ({}),
    },
    loadingData: {
      type: Boolean,
      default: false,
    },
    avaliacao: {
      type: Boolean,
      default: true,
    },
    titulo: {
      type: String,
      default: "",
    },
  },
  watch: {
    tracking() {
      this.clearHeatMap();
      this.heatMapData = null;
      this.setHeatMap();
    },
    polygons() {
      this.mapKey = "map" + Math.random();
      this.bounds = [];

      this.polygons.forEach((polygon) => {
        polygon.latlngs.forEach((latlng) => {
          this.bounds.push(latlng);
        });
      });

      if (this.bounds.length) {
        setTimeout(() => {
          this.fitBoundsGoogle();
        }, 100);
      }
    },
  },
  data() {
    return {
      mapKey: "map" + Math.random(),
      zoom: 4,
      center: {
        lat: -15.288423,
        lng: -49.851561,
      },
      bounds: [],
      showPins: true,
      heatMapData: null,
      showPolygons: true,
      showHeatMap: true,
      mapType: "satellite",
      mapTypes: [
        { label: this.$t("roadmap"), value: "roadmap" },
        { label: this.$t("sattellite"), value: "satellite" },
        { label: this.$t("hybrid"), value: "hybrid" },
        { label: this.$t("roadmap"), value: "terrain" },
      ],
      evaluation: null,
      evaluationOptions: [
        { name: "0%", value: 0 },
        { name: "25%", value: 25 },
        { name: "50%", value: 50 },
        { name: "75%", value: 75 },
        { name: "100%", value: 100 },
      ],
    };
  },
  methods: {
    formatDate(date) {
      if (!date) {
        return "";
      }
      return date.split("T")[0].split("-").reverse().join("/");
    },
    onlyTime(date) {
      if (!date) {
        return "";
      }
      return date.split("T")[1].split(".")[0].slice(0, 5);
    },
    googlePoints(value) {
      let map = new window.google.maps.LatLng(value.lat, value.lng);
      return map;
    },
    clearHeatMap() {
      if (this.heatMapData) {
        this.heatMapData.setMap(null);
      }
    },
    setHeatMap() {
      let point = [];

      this.tracking.forEach((item) => {
        if (item.tracking !== undefined) {
          item.tracking.forEach((track) => {
            point.push({
              location: this.googlePoints(track),
              weight: 10,
            });
          });
        }
      });

      setTimeout(() => {
        this.generateHeatmap(point);
      }, 200);
    },
    generateHeatmap(points) {
      this.$refs.googleMap.$mapPromise.then((map) => {
        this.heatMapData = new window.google.maps.visualization.HeatmapLayer({
          data: points,
          map: map,
          maxIntensity: 350,
          radius: 10,
          zIndex: 9999,
        });
      });
    },
    handleDistractClick() {
      this.$emit("distract", this.evaluation);
      this.evaluation = null;
    },
    fitBoundsGoogle() {
      this.$refs.googleMap.$mapPromise.then(() => {
        const b = new window.google.maps.LatLngBounds();
        for (let i of this.bounds) {
          b.extend({
            lat: i.lat,
            lng: i.lng,
          });
        }
        this.$refs.googleMap.fitBounds(b);
        this.$refs.googleMap.$mapObject.setZoom(16);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.contract-modal-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  color: #131e3b;
}

.map-container {
  height: 424px;
  width: 100%;
  position: relative;
}

.map-controllers {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 500;
  width: 118px;
}

.pins-controller {
  position: absolute;
  top: 64px;
  right: -52px;
  z-index: 500;
  width: 112px;
}

.polygon-controller {
  position: absolute;
  top: 114px;
  right: -52px;
  z-index: 500;
  width: 112px;
}

.heatmap-controller {
  position: absolute;
  top: 14px;
  right: -52px;
  z-index: 500;
  width: 112px;
}

.pin-marker {
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50% 50% 0 50%;
  background: #fff;
  border: 1px solid white;
  transform: rotate(45deg) !important;
  box-shadow: 0px 3px 5px rgba(9, 30, 66, 0.2);
}

.pin-qtd {
  position: absolute;
  color: #131e3b;
  width: 100%;
  text-align: center;
  left: 0;
  right: 0;
  top: 9px;
  font-size: 1rem;
  font-weight: bold;
  transform: rotate(-45deg) !important;
}

.timeline-modal {
  .timeline-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .timeline-info__item {
    border: 1px solid #c6c9d0;
    border-radius: 16px;
    width: 100%;
    height: 92px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 16px;
    padding-left: 16px;
  }

  .timeline-info__label {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.014em;
    color: #565e73;
  }

  .timeline-info__counter {
    font-family: "OpenSans-Regular";
    font-weight: 400;
    font-size: 18px;
    line-height: 32px;
    color: #565e73;
  }
}

.evaluation-title {
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: -0.014em;
  color: #131e3b;
}

.evaluation-date {
  font-family: "Montserrat";
  font-weight: 400;
  font-size: 13px;
  line-height: 156%;
  text-align: center;
  color: #565e73;
}

.evaluation-selector {
  width: 106px;
  z-index: 10;
  margin-right: 16px;
}

.timeline-photos {
  margin-right: 1px;
  margin-left: 1px;
  box-shadow: 0px 8px 12px rgba(160, 168, 189, 0.24);
  border-radius: 8px 8px 0px 0px;

  .timeline-header {
    padding: 24px;
    margin-bottom: 24px;
    border-bottom: 1px solid #dddee3;
  }

  .timeline-list {
    padding: 24px;
    padding-top: 0px;
  }

  .timeline-header__title {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.014em;
    color: #131e3b;
  }

  .activity-name {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.014em;
    color: #131e3b;
  }

  .activity-qtd {
    font-family: "OpenSans-Regular";
    font-weight: 600;
    font-size: 11px;
    line-height: 16px;
    color: #565e73;
  }

  .activity-date {
    font-family: "OpenSans-Regular";
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: -0.006em;
    color: #565e73;
  }

  .timeline-photo {
    font-family: "OpenSans-Regular";
    font-weight: 400;
    font-size: 12px;
    line-height: 156%;
    color: #838998;

    .timeline-img {
      border-radius: 16px;
    }
  }

  .timeline-header__subtitle {
    font-family: "OpenSans-Regular";
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: -0.006em;
    color: #565e73;
  }
}
.body-box {
  display: flex;
  flex-direction: row-reverse;
}
.timeline-box {
  width: 70%;
  max-height: 720px;
  min-height: 720px;
  margin-right: 30px;
  overflow-y: scroll;
}
.mapa {
  width: 100%;
  height: 520px;
}
.mapa2 {
  width: 100%;
  height: 720px;
}
.tela-mobile {
  display: none;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  margin-top: 25px;
}
.tela-monitor {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  margin-top: 25px;
}

@media screen and (min-width: 1px) and (max-width: 800px) {
  .body-box {
    flex-direction: column;
  }
  .mapa {
    width: 100%;
    height: 390px;
  }
  .timeline-box {
    width: 100%;
    max-height: 720px;
    margin-right: 0px;
    overflow-y: scroll;
  }
  .tela-mobile {
    display: flex;
  }

  .tela-monitor {
    display: none;
  }
}
</style>
